<template>
  <div class="wrapper" :class="'wrapper-' + $store.getters.platform">
    <app-loader v-if="!categories.length && !noData"></app-loader>
    <div v-else>
      <router-view :key="$route.fullPath" />

      <!-- categories -->
      <div style="padding: 2.6rem 0rem 2.6rem 0rem">
        <!-- previous -->
        <div style="text-align: center">
          <a v-if="previous"  @click="paginate('previous')" @keyup.enter="paginate('previous')" class="waves-effect waves-light btn-large focusable-previous" tabindex="-1">{{$t('GENERAL.PAGINATE-PREVIOUS')}}</a>
        </div>

        <div v-for="cat in categories" :key="cat.id" style="overflow: hidden;">
          <app-list v-if="!cat.is_final"
            :options="{
              id: cat.id,
              type: 'card-categories-products',
              title: cat.name,
              items: cat.child_categories,
              route: 'shop-category',
              card: cat.card,
              wrapper: $el
            }"
            @setLastFocused="setLastFocused($event)"
          />
          <app-list v-if="cat.is_final"
            :options="{
              id: cat.id,
              type: 'card-products',
              title: cat.name,
              items: cat.category_product,
              route: 'shop-product',
              card: cat.card,
              wrapper: $el
            }"
            @setLastFocused="setLastFocused($event)"
          />
        </div>

        <!-- next -->
        <div style="text-align: center">
          <a v-if="next"  @click="paginate('next')" @keyup.enter="paginate('next')" class="waves-effect waves-light btn-large focusable-next" tabindex="-1">{{$t('GENERAL.PAGINATE-NEXT')}}</a>
        </div>
      </div>

      <!-- control bar -->
      <ControlBar v-if="$store.getters.getData.control_bar && $store.getters.platform !== 'browser'" :keys="keys" />

      <div id="back-browser-root" ref="back" class="back-browser fadein-browser"
      @click="back" v-if="$store.getters.platform === 'browser'" v-show="$route.name !== 'shop'">
        <icon name="arrow-left"></icon>
      </div>

    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import ControlBar from '@/components/ControlBar'
import {StatsRootProductCategories} from '@/utils/constants'
const productsService = require('@/services/products.js')

export default {
  name: 'RootProductCategories',
  components: { 'app-list': List, 'app-loader': Loader, ControlBar },
  data () {
    return {
      categories: {},
      noData: false,
      lastFocused: null,
      keys: [
        {text: this.$i18n.t('KEYS.EXIT'), action: this.$i18n.t('KEYS.CLOSE')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'red', action: this.$i18n.t('KEYS.TOP')}
      ],
      previous: false,
      next: false,
      setInterval: false,
      time: 0
    }
  },
  watch: {
    // al volver de otra ruta hacemos focus sobre la última lista seleccionada
    $route: function () {
      if (this.$route.name === 'shop') {
        SpatialNavigation.focus(this.lastFocused)
        SpatialNavigation.resume()
      }

      document.querySelector('body').style.overflowY = 'auto'
    }
  },
  created: function () {
    // CATEGORÍAS
    if (this.$store.getters.getData.type_shop === 'A2C') {
      this.categoriesA2C = []
      this.finalCategories = []

      // creamos el árbol de categorías
      productsService.categoriesA2C({}).then(response => {
        this.$store.commit('shopCategories', response.data.category)

        // prestashop
        let root = response.data.category.filter(item => { return item.parent_id === null })[0]
        let rootId = !root ? '0' : root.id

        let rootCategories = response.data.category.filter(item => { return item.parent_id === rootId })
        for (let i = 0; i < rootCategories.length; i++) {
          let childs = response.data.category.filter(item => { return item.parent_id === rootCategories[i].id })
          let items = []

          // categoría
          let cat = {
            id: rootCategories[i].id,
            name: rootCategories[i].name
          }

          if (childs.length) {
            cat.is_final = false

            // subcategorías
            for (let j = 0; j < childs.length; j++) {
              let img = childs[j].images.length ? childs[j].images[0].http_path : ''
              items.push({
                id: childs[j].id,
                name: childs[j].name,
                image: img
              })
            }
            cat.child_categories = items
          } else {
            cat.is_final = true
            // guardamos categorías finales para recuperar contenidos
            this.finalCategories.push(rootCategories[i].id)
            cat.category_product = []
          }
          // recuperamos contenidos
          this.categoriesA2C.push(cat)
        }
        this.contentsA2C()
      })
    } else {
      productsService.listCategories().then(response => {
        this.categories = response.data['results']

        // sin categprías
        if (!this.categories.length) {
          this.noData = true
          SpatialNavigation.resume()
          SpatialNavigation.focus()
        }

        this.next = response.data.next
        if (this.next) {
          SpatialNavigation.add({selector: '.focusable-next', restrict: 'self-first'})
          SpatialNavigation.makeFocusable()
        }
      })
    }

    // keys control
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-red', this.keyRed)
  },
  beforeMount: function () {
    window.Countly.q.push(['track_pageview', StatsRootProductCategories])
    window.scrollTo(0, 0)
  },
  mounted: function () {
    // back browser
    if (this.$store.getters.platform === 'browser') {
      this.setInterval = setInterval(() => {
        this.time = this.time + 1
        if (this.time >= 3 && this.$refs.back) {
          this.$refs.back.classList.remove('fadein-browser')
          this.$refs.back.classList.add('fadeout-browser')
        }
      }, 1000)

      this.$el.addEventListener('mousemove', () => {
        if (this.$refs.back) {
          this.$refs.back.classList.remove('fadeout-browser')
          this.$refs.back.classList.add('fadein-browser')
        }
        this.time = 0
      })
    }
  },
  methods: {
    contentsA2C: function () {
      let countRequests = 0
      for (let i = 0; i < this.finalCategories.length; i++) {
        productsService.productsA2C({category_id: this.finalCategories[i]}).then(response => {
          // añadimos contenidos a categorías
          let cat = this.categoriesA2C.filter(item => { return item.id === this.finalCategories[i] })[0]
          let items = []

          for (let k = 0; k < response.data.product.length; k++) {
            let img = response.data.product[k].images.filter((a) => (a.type === 'IMAGE_TYPE_BASE'))[0]

            items.push({
              id: response.data.product[k].id,
              name: response.data.product[k].name,
              image: img.http_path
            })
          }
          cat.category_product = items

          // comprobamos si hemos recuperado todas las categorías
          countRequests++
          if (countRequests === this.finalCategories.length) { this.categories = this.categoriesA2C }
        }).catch(() => {
          // añadimos contenidos a categorías
          let cat = this.categoriesA2C.filter(item => { return item.id === this.finalCategories[i] })[0]
          let items = []

          cat.category_product = items

          // comprobamos si hemos recuperado todas las categorías
          countRequests++
          if (countRequests === this.finalCategories.length) { this.categories = this.categoriesA2C }
        })
      }
    },
    back: function () { this.$router.go(-1) },
    keyBack () {
      if (this.$route.name === 'shop') {
        if (this.previous) {
          this.paginate('previous')
        } else {
          this.$router.replace({name: 'content'})
        }
      }
    },
    keyRed () {
      if (this.$route.name === 'shop' && this.$store.getters.getData.control_bar && this.$store.getters.platform !== 'browser') {
        SpatialNavigation.focus()
      }
    },
    setLastFocused (e) { this.lastFocused = e.id },
    paginate: function (action) {
      if (this[action]) {
        this.categories = []
        productsService.paginate(this[action]).then(response => {
          this.categories = response.data['results']
          this.previous = response.data.previous
          this.next = response.data.next

          if (this.previous) {
            SpatialNavigation.add({selector: '.focusable-previous', restrict: 'self-first'})
            SpatialNavigation.makeFocusable()
          }

          if (this.next) {
            SpatialNavigation.add({selector: '.focusable-next', restrict: 'self-first'})
            SpatialNavigation.makeFocusable()
          }
        })
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.setInterval)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-red', this.keyRed)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  width: 100%;
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox

</style>



// WEBPACK FOOTER //
// src/pages/products/RootProductCategories.vue